var map = {
	"./img_bg.png": 61158,
	"./img_can.png": 86458,
	"./img_chn081.png": 77159,
	"./img_faq.png": 91539,
	"./img_fra.png": 85414,
	"./img_gbr.png": 93023,
	"./img_idn.png": 88545,
	"./img_ind.png": 90224,
	"./img_kor.png": 39390,
	"./img_map.png": 55982,
	"./img_more.png": 28607,
	"./img_usa.png": 38263
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36583;